import { LoadScript } from "@react-google-maps/api";
import AddressAutoCompleteCore from "./AddressAutoCompleteCore";

// Choose where to put this (e.g., around your AddressAutoComplete or high up in your router/App.tsx)
const libraries = ["places"]; // ⚠️ Crucial: Must include 'places'

interface AddressAutoCompleteProps {
  onSelectAddress: (data: any) => void;
  address: string;
  setAddress: (address: string) => void;
  error?: string | null;
  countryCode: string;
  stateName?: string;
  cityName?: string;
}

const AddressAutoComplete = ({
  onSelectAddress,
  address,
  setAddress,
  error,
  stateName,
  countryCode,
  cityName,
}: AddressAutoCompleteProps) => {
  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? ""}
      libraries={libraries as any}
    >
      <AddressAutoCompleteCore
        onSelectAddress={onSelectAddress}
        address={address}
        setAddress={setAddress}
        error={error}
        countryCode={countryCode}
        stateName={stateName}
        cityName={cityName}
      />
    </LoadScript>
  );
};

export default AddressAutoComplete;
